"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillDataInitRequest = void 0;
var BillDataInitRequest = /** @class */ (function () {
    function BillDataInitRequest() {
    }
    return BillDataInitRequest;
}());
exports.BillDataInitRequest = BillDataInitRequest;
;
//# sourceMappingURL=billDataInit.request.js.map